import React, {memo} from 'react';
import parser from 'html-react-parser';
import Container from '@/components/atoms/Container';
import Marquee from '@/components/atoms/Marquee';
import Eyebrow from '@/components/atoms/Eyebrow';
import OptimizedImage from '@/components/atoms/OptimizedImage';
import styles from './AIModelIntegration.module.scss';

interface AIModelIntegrationProps {
    eyebrow?: string;
    heading: string;
    subheading: string;
    contentData: Array<{
        title: string;
        src: any;
    }>;
}

const logoImageStyle: React.CSSProperties = {objectFit: 'contain', width: '100%', height: '100%'};

const AIModelIntegration = ({eyebrow, heading, subheading, contentData}: AIModelIntegrationProps) => {
    return (
        <div className={`top-space mobile-top-padding bottom-spacing mobile-bottom-padding ${styles.section}`}>
            <Container>
                {/* Section Header */}
                <div className={styles.header}>
                    {eyebrow && <Eyebrow text={eyebrow} />}
                    <h2 className={`font-headers ${styles.heading}`}>{heading}</h2>
                    <p className={`font-regular-text generative-transforming-subheading ${styles.subheading}`}>
                        {subheading ? parser(subheading) : ''}
                    </p>
                </div>

                {/* Infinite Logos Marquee */}
                <Marquee className={styles.marqueeRow} trackClassName={styles.row}>
                    {contentData?.map((item, index) => (
                        <div key={index} className={styles.logoCard}>
                            <div className={styles.imageWrapper}>
                                <OptimizedImage src={item.src} alt={item.title} style={logoImageStyle} />
                            </div>
                            <p className={`font-headers ${styles.logoTitle}`}>{item.title}</p>
                        </div>
                    ))}
                </Marquee>
            </Container>
        </div>
    );
};

export default memo(AIModelIntegration);
